mutation TravelerUploadDocument(
  $document: DocumentUploadInput!
  $travelerId: UUID!
) {
  travelerUploadDocument(document: $document, travelerId: $travelerId) {
    uploadLink
    document {
      _documentFileId
      travelerDocument {
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
      }
    }
  }
}
